
import React from 'react';
import Show from '../../components/Show/Show';
import { AuthenticatedApp } from '../../components/Root/AuthenticatedApp';
import { NavigationForSmallScreen } from '../../components/NavigationPanel/NavigationForSmallScreen';
import { NavigationMenuVisibilityProvider } from '../../components/NavigationPanel/NavigationMenuVisibilityContext';
import { NavigationPrivateWeb } from '../../components/NavigationPanel/NavigationPrivateWeb';
import { useIsSmallWeb } from '../../hooks/ui/useIsSmallWeb';






export default function Layout(){
  const {isSmallWeb} = useIsSmallWeb();

  return (
    <AuthenticatedApp>
      <Show when={!isSmallWeb} fallback={<NavigationForSmallScreen />}>
        <NavigationMenuVisibilityProvider>
          <NavigationPrivateWeb />
        </NavigationMenuVisibilityProvider>
      </Show>
    </AuthenticatedApp>
  );
}


